<script>
    // Every unknown path used to render the landing page, at whatever URL had
    // been typed. /privacy showed the homepage with /privacy still in the
    // address bar, which is how the footer could link a policy that did not
    // exist without anything ever looking broken.
    import Button from '../components/Button.svelte';
    import EmptyState from '../components/EmptyState.svelte';
</script>

<div class="u-page">
    <EmptyState
        title="That page isn’t here"
        body="The link may be old, or the address may have a typo in it."
    >
        <Button href="/">Back to home</Button>
    </EmptyState>
</div>
